import {LimitConverter} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/repeater/LimitConverter';
import {RepeaterModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/repeater/RepeaterModel';
import {RepeaterModelEditor} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/repeater/RepeaterModelEditor';
import {IPropertyTypeConfig} from '@mintdata/mint-kit/api/properties/PropertyTypeConfig';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {BaseFieldConverter} from '@mintdata/mint-kit/impl/properties/converters/BaseFieldConverter';
import {AIntegerEditor} from '@mintdata/mint-kit/impl/properties/editors/AIntegerEditor';

export const RepeaterModelConfig:IPropertyTypeConfig<RepeaterModel> =
    {
        converter: BaseFieldConverter,
        editor: RepeaterModelEditor
    };

export const LimitConfig:IPropertyTypeConfig<AInteger> =
    {
        converter: LimitConverter,
        editor: AIntegerEditor,
    };
